<div class="js-menu-list sub-menu">
  <div class="box-title" (click)="close($event)" (keyup.enter)="close($event)" [attr.tabindex]="0">
    <nav-arrow-left></nav-arrow-left>

    <nav-label [node]="removeUrl(node)" classContainer="title"></nav-label>
  </div>

  <ul class="menu-list">
    @if (node.url) {
      <li>
        <nav-label [node]="node" class="w-100 nav-node__menu-link"></nav-label>
      </li>
    }
    @for (item of node?.children; track item) {
      <li class="js-menu-item w-100">
        @if (item.children?.length) {
          <nav-label
            [node]="removeUrl(item)"
            classContainer="item-list"
            (click)="open($event)"
            (keyup.enter)="open($event)"
            [attr.tabindex]="0"
          ></nav-label>
          <div style="flex-grow: 1">
            <nav-arrow-right></nav-arrow-right>
            <sub-menu [node]="item"></sub-menu>
          </div>
        } @else {
          <nav-label [node]="item" classContainer="item-list w-100"></nav-label>
        }
      </li>
    }
  </ul>
</div>
